export function normalizePromptFragment(value: unknown) {
  return String(value || '').replace(/\s+/g, ' ').trim()
}

export function normalizePromptList(value: unknown) {
  if (Array.isArray(value)) {
    return value.map((item) => normalizePromptFragment(item)).filter(Boolean)
  }
  const single = normalizePromptFragment(value)
  return single ? [single] : []
}

export function joinPromptFragments(items: Array<unknown>, separator = '，') {
  const seen = new Set<string>()
  const result: string[] = []

  items.forEach((item) => {
    const normalized = normalizePromptFragment(item)
    if (!normalized || seen.has(normalized)) {
      return
    }
    seen.add(normalized)
    result.push(normalized)
  })

  return result.join(separator)
}